module.exports = __webpack_public_path__ + "static/media/happy-house.242542c6.svg";